<template>
  <div class="flash-message-cover">
    <div class="flash-message">
      <span class="message">{{ message }}</span>
      <img src="@/assets/icons/no_result.svg?url" alt="Message">
      <button class="close" @click="close">Close</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      message: {
        type: String,
        required: true,
      },
    },
    methods: {
      close() {
        this.$emit('closeFlash');
      },
    },
  };
</script>

<style lang="scss">
  .flash-message-cover {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0,0,0,0.6);
    z-index: 1009;
  }

  .flash-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    z-index: 1001;
    text-align: center;

    @media (max-width: 600px) {
      width: 200px;
      padding: 50px 20px;
    }

    img {
      width: 80%;
      min-width: 200px;
      max-width: 250px;
    }

    .message {
      color: #ffffff;
      font-family: 'Nunito-ExtraBold';
      font-size: 25px;
      text-align: center;
      display: block;
      margin-bottom: 20px;

      @media (max-width: 768px) {
        font-size: 22px;
      }

      @media (max-width: 425px) {
        font-size: 16px;
      }
    }

    .close {
      color: #ffffff;
      font-family: 'Nunito-ExtraBold';
      font-size: 18px;
      text-align: center;
      outline: none;
      border: 2px solid #ffffff;
      border-radius: 20px;
      background-color: transparent;
      padding: 10px;
      width: 90%;
      cursor: pointer;

      &:hover {
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
        transform: scale(1);
        animation: pulse_button 2s infinite;

        @keyframes pulse_button {
          0% {
            -webkit-transform: scale(0.95);
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
          }
          70% {
            -webkit-transform: scale(1);
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
          }
          100% {
            -webkit-transform: scale(0.95);
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
          }
        }
      }
    }
  }
</style>